import React from 'react'
import { Column } from '../../../Grid'
import cn from 'classnames'

import './index.scss'

const UbliqueColumn = (props) => {
  const { sm = 4, md = 8, lg = 12, children, className } = props

  return (
    <Column sm={sm} md={md} lg={lg} className={cn('stripe-column', className)}>
      {children}
    </Column>
  )
}

export default UbliqueColumn
